export const GET_COMPANIES_REQUEST = "GET_COMPANIES_REQUEST";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_FAILURE = "GET_COMPANIES_FAILURE";

export const GET_COMPANY_REQUEST = "GET_COMPANY_REQUEST";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAILURE = "GET_COMPANY_FAILURE";

export const SUBMIT_COMPANY_REQUEST = "SUBMIT_COMPANY_REQUEST";
export const SUBMIT_COMPANY_SUCCESS = "SUBMIT_COMPANY_SUCCESS";
export const SUBMIT_COMPANY_FAILURE = "SUBMIT_COMPANY_FAILURE";

export const SET_COMPANIES = "SET_COMPANIES";
export const SET_COMPANY = "SET_COMPANY";

export const TEST_EMAIL_SUCCESS = "TEST_EMAIL_SUCCESS";
export const TEST_EMAIL_FAILURE = "TEST_EMAIL_FAILURE";
export const TEST_EMAIL_REQUEST = "TEST_EMAIL_REQUEST";

export const GET_PLANS_REQUEST = "GET_PLANS_REQUEST";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLANS_FAILURE = "GET_PLANS_FAILURE";

export const GET_COMPANY_PLANS_REQUEST = 'GET_COMPANY_PLANS_REQUEST';
export const GET_COMPANY_PLANS_SUCCESS = 'GET_COMPANY_PLANS_SUCCESS';
export const GET_COMPANY_PLANS_FAILURE = 'GET_COMPANY_PLANS_FAILURE';


export const testEmailRequest = (testEmail, companyId) => ({
    type: TEST_EMAIL_REQUEST,
    payload: {
        testEmail:testEmail,
        companyId:companyId
    }
})
export const testEmailSuccess = () => ({
    type: TEST_EMAIL_SUCCESS
})
export const testEmailFailure = err => ({
    type: TEST_EMAIL_FAILURE,
    error: err
})

export const getCompaniesRequest = (filters = {}) => ({
    type: GET_COMPANIES_REQUEST,
    payload: {
        filters
    }
});

export const getCompaniesSuccess = companies => ({
    type: GET_COMPANIES_SUCCESS,
    payload: {
        companies
    }
});

export const getCompaniesFailure = err => ({
    type: GET_COMPANIES_FAILURE,
    error: err
});

export const getPlansRequest = (filters = {}) => ({
    type: GET_PLANS_REQUEST,
    payload: {
        filters
    }
});

export const getPlansSuccess = plans => ({
    type: GET_PLANS_SUCCESS,
    payload: {
        plans
    }
});

export const getPlansFailure = err => ({
    type: GET_PLANS_FAILURE,
    error: err
});

export const getCompanyPlansRequest = (companyId) => ({
    type: GET_COMPANY_PLANS_REQUEST,
    payload: {
        companyId
    }
});

export const getCompanyPlansSuccess = (company, plans, total) => ({
    type: GET_COMPANY_PLANS_SUCCESS,
    payload: {
        company,
        plans,
        total
    }
});

export const getCompanyPlansFailure = (err) => ({
    type: GET_COMPANY_PLANS_FAILURE,
    error: err
});

export const getCompanyRequest = (filters = {}) => ({
    type: GET_COMPANY_REQUEST,
    payload: {
        filters
    }
});

export const getCompanySuccess = company => ({
    type: GET_COMPANY_SUCCESS,
    payload: {
        company
    }
});

export const getCompanyFailure = err => ({
    type: GET_COMPANY_FAILURE,
    error: err
});

export const submitCompanyRequest = company => ({
    type: SUBMIT_COMPANY_REQUEST,
    payload: { company }
});

export const submitCompanySuccess = company => ({
    type: SUBMIT_COMPANY_SUCCESS,
    payload: {
        company
    }
});

export const submitCompanyFailure = err => ({
    type: SUBMIT_COMPANY_FAILURE,
    error: err
});

export const setCompanies = (companies = []) => ({
    type: SET_COMPANIES,
    payload: {
        companies
    }
})

export const setCompany = (company = {}) => ({
    type: SET_COMPANY,
    payload: {
        company
    }
})